import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import BaseInput from "../../../../toolkit/baseInput";
import ModalFrame from "../../../../toolkit/modalFrame";
import constants from "../../../../utils/constants";
import s from "./styles.scss";

interface Props {
  isModalOpen: boolean;
  onClose: () => void;
  data: any;
}

class PayComplementResultModal extends React.Component<Props> {
  render() {
    return (
      <Container className="p-0">
        <ModalFrame
          title={`Resultado timbrado complemento de pago`}
          isOpen={this.props.isModalOpen}
          size="md"
        >
          <Row className="mt-4">
            <Col xs={8}>
              <BaseInput
                type="text"
                label="UUID"
                name="payComplementUuid"
                id="payComplementUuid"
                value={(this.props.data || {}).complementoPagoUUID || ""}
                disabled={true}
              />
            </Col>

            <Col xs={4} className="p-4">
              <Button
                block
                color="primary"
                onClick={() => {
                  const url = `${constants.BASE_URL}/${
                    constants.DOCUMENTS_BASE_URL
                  }/${(this.props.data || {}).archivoPdfStorageId || ""}`;
                  window.open(url, "_blank");
                }}
              >
                Abrir PDF
              </Button>
            </Col>
          </Row>

          <Row className="mt-4 mb-4">
            <Col xs={12}>
              <Button
                block
                color="secondary"
                onClick={() => {
                  if (!!this.props.onClose) {
                    this.props.onClose();
                  }
                }}
              >
                CERRAR
              </Button>
            </Col>
          </Row>
        </ModalFrame>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(PayComplementResultModal));
